import { Divider, mergeClasses, Text } from "@fluentui/react-components";
import { Info16Regular } from "@fluentui/react-icons";
import { useStyle } from "./style";
import { useIntl } from "react-intl";
import { ChangeEvent, useState } from "react";
import { EmailSubjectInputProps } from "./types";
import { Flex, GapSize } from "@/components/atoms/flex";

export const EmailSubjectInput = (props: EmailSubjectInputProps) => {
	const {
		data,
		onChange,
		isReadOnlyMode,
		emailHasDraft,
		isFirstEmailInConversation,
	} = props;
	const classes = useStyle();
	const intl = useIntl();

	const [isSubjectFocused, setIsSubjectFocused] = useState<boolean>(false);

	const subjectInput = (
		<>
			<Divider />
			<Flex
				hAlign="space-between"
				vAlign="center"
				className={!isFirstEmailInConversation ? classes.subjectContainer : ""}
			>
				<input
					className={mergeClasses(
						classes.subjectInput
					)}
					placeholder={intl.formatMessage({
						id: "Interaction.EmailEditor.SubjectPlaceholder",
					})}
					value={data.subject}
					onChange={(e: ChangeEvent<HTMLInputElement>) => {
						const value = e.currentTarget.value;

						onChange(
							{
								...data,
								subject: value,
							},
							false,
							emailHasDraft,
						"EmailSubjectInput.onChange"
						);
					}}
					onFocus={() => {
						setIsSubjectFocused(true);
					}}
					disabled={isReadOnlyMode}
				/>
			</Flex>
			{isSubjectFocused && !isFirstEmailInConversation && (
				<Flex
					vAlign="center"
					gap={GapSize.Small}
					className={classes.subjectInfo}
				>
					<Info16Regular className={classes.subjectInfoIcon} />
					<Text size={200}>
						{intl.formatMessage({
							id: "Interaction.EmailEditor.SubjectInfoTooltip",
						})}
					</Text>
				</Flex>
			)}
		</>
	);

	return subjectInput;
};
